import { render } from "./AddDeliveryAddress.vue?vue&type=template&id=86ca5360"
import script from "./AddDeliveryAddress.vue?vue&type=script&lang=js"
export * from "./AddDeliveryAddress.vue?vue&type=script&lang=js"

import "./AddDeliveryAddress.vue?vue&type=style&index=0&id=86ca5360&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__